import React, { useState } from "react";
import { Link } from "react-router-dom";

// const menu_data = [
//   {
//     id: 1,
//     title: "Home",
//     link: "/",
//     has_dropdown: true,
//     sub_menu: [
//       {
//         id: 1,
//         title: "Digital Agency",
//         link: "/",
//       },
//       {
//         id: 2,
//         title: "Startup Agency",
//         link: "/startup-agency",
//       },
//       {
//         id: 3,
//         title: "Design Studio",
//         link: "/design-studio",
//       },
//       {
//         id: 4,
//         title: "Creative Protfolio",
//         link: "/creative-protfolio",
//       },
//       {
//         id: 5,
//         title: "Marketing Agency",
//         link: "/marketing-agency",
//       },
//     ]
//   },
//   {
//     id: 2,
//     title: "About",
//     link: '/about',
//     has_dropdown: false
//   },
//   {
//     id: 3,
//     title: "Pages",
//     link: "/about",
//     has_dropdown: true,
//     sub_menu: [
//       {
//         id: 1,
//         title: "About",
//         link: "/about",
//       },
//       {
//         id: 2,
//         title: "Team",
//         link: "/team",
//       },
//       {
//         id: 3,
//         title: "Team Details",
//         link: "/team-details",
//       },
//       {
//         id: 4,
//         title: "Contact",
//         link: "/contact",
//       },
//       {
//         id: 5,
//         title: "Faq",
//         link: "/faq",
//       },
//       {
//         id: 6,
//         title: "Error",
//         link: "/error",
//       }
//     ]
//   },
//   {
//     id: 4,
//     title: "Services",
//     link: "/service",
//     has_dropdown: true,
//     sub_menu: [
//       {
//         id: 1,
//         title: "Services",
//         link: "/service",
//       },
//       {
//         id: 2,
//         title: "Services Details",
//         link: "/service-details",
//       }
//     ]
//   },
//   {
//     id: 5,
//     title: "Portfolio",
//     link: "/portfolio",
//     has_dropdown: true,
//     sub_menu: [
//       {
//         id: 1,
//         title: "Portfolio",
//         link: "/portfolio",
//       },
//       {
//         id: 2,
//         title: "Portfolio Details",
//         link: "/portfolio-details",
//       }
//     ]
//   },
//   {
//     id: 6,
//     title: "Blog",
//     link: "/blog",
//     has_dropdown: true,
//     sub_menu: [
//       {
//         id: 1,
//         title: "Blog",
//         link: "/blog",
//       },
//       {
//         id: 2,
//         title: "Blog Details",
//         link: "/blog-details",
//       }
//     ]
//   },
//   {
//     id: 7,
//     title: "Contact",
//     link: "/contact",
//     has_dropdown: false,
//   }

// ]

const menu_data = [
  {
    id: 1,
    title: "Home",
    link: "/",
    has_dropdown: false,
  },
  {
    id: 2,
    title: "About Us",
    link: "/about_us",
    has_dropdown: false,
  },
  // {
  // 	id: 3,
  // 	title: "Pages",
  // 	link: "/about",
  // 	has_dropdown: true,
  // 	sub_menu: [
  // 		{
  // 			id: 1,
  // 			title: "About",
  // 			link: "/about",
  // 		},
  // 		{
  // 			id: 2,
  // 			title: "Team",
  // 			link: "/team",
  // 		},
  // 		{
  // 			id: 3,
  // 			title: "Team Details",
  // 			link: "/team-details",
  // 		},
  // 		{
  // 			id: 4,
  // 			title: "Contact",
  // 			link: "/contact",
  // 		},
  // 		{
  // 			id: 5,
  // 			title: "Faq",
  // 			link: "/faq",
  // 		},
  // 		{
  // 			id: 6,
  // 			title: "Error",
  // 			link: "/error",
  // 		}
  // 	]
  // },
  {
    id: 3,
    title: "Services",
    link: "/services",
    has_dropdown: true,
    sub_menu: [
      {
        id: 1,
        title: "SEO Service",
        link: "/seo-services-india",
      },
      {
        id: 2,
        title: "SMM Service",
        link: "/Best-social-media-marketing-company-in-Jabalpur-India",
      },
      {
        id: 3,
        title: "PPC Google Adwords",
        link: "/ppc",
      },
      {
        id: 4,
        title: "Digital Marketing",
        link: "/Best-Digital-Marketing-Company-India",
      },
      {
        id: 5,
        title: "Software and Website Developement",
        link: "/Best-Software-Company-in-Jabalpur",
      },
      {
        id: 6,
        title: "Mobile App Development",
        link: "/mobile-development",
      },
      {
        id: 7,
        title: "Graphic Designing",
        link: "/graphic-designing",
      },
      {
        id: 8,
        title: "Data Analysis",
        link: "/data-analysis",
      },
      {
        id: 9,
        title: "Vetted Developers",
        link: "/vetted-developers-in-india",
      },
      {
        id: 9,
        title: "AI Automation Services",
        link: "/ai-automation-services-India",
      },
      {
        id: 10,
        title: "WhatsApp Bulk Messaging",
        link: "/bulk-whatsapp-marketing-service",
      },
      {
        id: 11,
        title: "SMS Bulk Messaging",
        link: "./bulk-sms-service",
      },
    ],
  },
  {
    id: 4,
    title: "Our Products",
    link: "/",
    has_dropdown: true,
    sub_menu: [
      {
        id: 1,
        title: "MedBrainix",
        link: "https://medbrainix.com",
      },
      {
        id: 2,
        title: "CRM",
        link: "https://crm-generalize.siarasystems.com",
      },
      {
        id: 3,
        title: "Revenue Engine",
        link: "https://revenueengine.doaguru.com",
      },
    ],
  },
  {
    id: 5,
    title: "Portfolio",
    link: "/portfolio",
    has_dropdown: true,
    sub_menu: [
      {
        id: 1,
        title: "Websites",
        link: "/portfolio-website",
      },
      {
        id: 2,
        title: "Graphics/Video",
        link: "/portfolio-graphics",
      },
      {
        id: 3,
        title: "SMO & SMM",
        link: "/portfolio-smm-smo",
      },
      {
        id: 4,
        title: "Softwares",
        link: "/portfolio-software",
      },
      {
        id: 5,
        title: "DM Portfolio",
        link: "/portfolio-digital-marketing",
      },

      {
        id: 6,
        title: "Case Studies",
        link: "/case-studies",
      },
    ],
  },
  {
    id: 7,
    title: "Blogs",
    link: "/blogslist",
    has_dropdown: true,
    sub_menu: [
      {
        id: 1,
        title: "Blogs",
        link: "/blogslist",
      },
      {
        id: 2,
        title: "YouTube Videos",
        link: "/youtube-videos",
      },
    ],
  },
  {
    id: 8,
    title: "Careers",
    link: "/career",
    has_dropdown: false,
  },
  {
    id: 9,
    title: "Contact Us",
    link: "/contact_us",
    has_dropdown: false,
  },
];

const MobileMenu = ({ active, navTitle, openMobileMenu, handleActive }) => {
  return (
    <>
      <ul
        className="cs_nav_list"
        style={{ display: active ? "block" : "none" }}
      >
        {menu_data.map((menu) => (
          <li
            key={menu.id}
            className={`colorWhite ${
              menu.has_dropdown ? "menu-item-has-children" : ""
            } ${navTitle === menu.title ? "active" : ""}`}
          >
            <Link to={menu.link} onClick={handleActive}>
              {menu.title}
            </Link>
            {menu.has_dropdown && (
              <>
                <ul
                  className="cs_mega_wrapper"
                  style={{
                    display: navTitle === menu.title ? "block" : "none",
                  }}
                >
                  {menu.sub_menu?.map((subMenu) => (
                    <li key={subMenu.id} style={{ color: "black" }}>
                      <Link to={subMenu.link} onClick={handleActive}>
                        {subMenu.title}
                      </Link>
                    </li>
                  ))}
                </ul>
                <span
                  onClick={() => openMobileMenu(menu.title)}
                  className={`cs_munu_dropdown_toggle ${
                    navTitle === menu.title ? "active" : ""
                  }`}
                ></span>
              </>
            )}
          </li>
        ))}
      </ul>
    </>
  );
};

export default MobileMenu;
